import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/ui";
import { BenefitPartnerListDT } from "../../components/DataTables/BenefitPartnerListDT";

export const BenefitPartners = () => {
  const navigate = useNavigate();

  return (
    <div className="p-card gap-4 p-3">
      <PageHeader
        title="Partners de beneficios"
        onCreate={() => navigate("new")}
        createLabel="Crear partner"
      />
      <BenefitPartnerListDT />
    </div>
  );
};
